import { Empty, Skeleton, Table, Tabs, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { map, get } from "lodash";

import { recordError } from "../../utils/logService";
import service from "../../services/documentRepoService";
import {
  CheckboxSwitchery,
  Messages,
  Notify,
  openNotification, 
  SearchControl,
  util
} from '@seims/shared';

import { isAuthorizedRole } from "@seims/shared/src/security";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

export default function ListDocument(props) {
  const {
    hasUpdated,
    showModal,
    isUploader,
    isRatifer,
    setMainTitle,
    defaultTitle,
  } = props;

  const myUploads = "My Uploads";
  const ratificationQueue = "Ratification Queue";
  const sortDirections = ["ascend", "descend", "ascend"];
  const ratifiedRecords = "Ratified Documents";

  const uploadingRatifier = isUploader && isRatifer;
  const initTab = isUploader ? myUploads : ratificationQueue;

  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [docData, setDocData] = useState([]);
  const [currentTab, setCurrentTab] = useState(initTab);

  const tabList = [
    {
      key: myUploads,
      label: myUploads,
    },
    {
      key: ratificationQueue,
      label: ratificationQueue,
    },
    {
      key: ratifiedRecords,
      label: ratifiedRecords,
      visible: true,
    },
  ].filter((item) =>
    isAuthorizedRole(["ADMIN"]) ? item : item.visible === undefined
  );

  let msg = "";

  useEffect(() => {
    toggleMainTitle(initTab);
    if (hasUpdated === true) {
      getUserDocuments();
    }
  }, [hasUpdated, currentTab]);

  const getUserDocuments = async (selectedTab = currentTab) => {
    try {
      setLoading(true);
      const response =
        selectedTab === myUploads
          ? await service.getUserDocuments()
          : selectedTab === ratificationQueue
          ? await service.getRatificationQueue()
          : await service.getAllRatifiedDocuments(true);

      if (response && response.status === 200) {
        const { data } = response.data;

        const sorted =
          currentTab === ratificationQueue
            ? data.sort((a, b) => a.uploadDate.localeCompare(b.uploadDate))
            : data.sort((a, b) => b.uploadDate.localeCompare(a.uploadDate));
        setDocData(sorted);
        setFilteredData(sorted);
      } else {
        setDocData([]);
        setFilteredData([]);
      }

      setLoading(false);
    } catch (error) {
      recordError(error);
    }
  };

  const onTabChange = (selectedTab) => {
    setCurrentTab(selectedTab);
    getUserDocuments(selectedTab);
  };

  const toggleMainTitle = (selectedTab) => {
    if (uploadingRatifier || selectedTab === ratifiedRecords) {
      setMainTitle(defaultTitle);
    } else {
      setMainTitle(selectedTab);
    }
  };

  const confirmOwnDelete = async (id) => {
    try {
      const response = await service.deleteOwnDocument(id);
      if (response && response.status === 200) {
        msg = util.parseMessage(Messages.DELETE_SUCCESS, "Documents");
        openNotification("Document deletion", msg, Notify.SUCCESS);
        getUserDocuments();
        return;
      }

      msg = util.parseMessage(Messages.DELETE_FAILURE, "Documents");
      openNotification("Document Deletion Failed", msg, Notify.ERROR);
    } catch (error) {
      recordError(error);
      msg = util.parseMessage(Messages.DELETE_FAILURE, "Documents");
      openNotification("Document Deletion Failed", msg, Notify.ERROR);
    }
  };
  const confirmDisabling = async (record, activate) => {
    const { id } = record;
    var action = activate ? "disabling" : "enabling";
    try {
      const data = {
        publicationId: id,
        disabled: activate,
      };
      const response = await service.disableRatifiedDocument(data);
      if (response && response.status === 200) {
        msg = util.parseMessage(Messages.DISABLE_SUCCESS, "Document " + action);
        openNotification("Document Action", msg, Notify.SUCCESS);
        getUserDocuments();
        return;
      }

      msg = util.parseMessage(Messages.DISABLE_FAILURE, "Document " + action);
      openNotification("Document Action", msg, Notify.ERROR);
    } catch (error) {
      recordError(error);
      msg = util.parseMessage(Messages.DISABLE_FAILURE, "Document " + action);
      openNotification("Document Action", msg, Notify.ERROR);
    }
  };
  const handleInputChange = (e) => {
    const { value: searchValue } = e.target;
    setSearchText(searchValue);
    globalSearch(searchValue);
  };

  const globalSearch = (searchValue) => {
    if (searchText === "") {
      setFilteredData(docData);
      return;
    }

    const reg = new RegExp(
      searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"),
      "gi"
    );

    var _filteredData = map(docData, (record) => {
      const titleMatch = get(record, "title").match(reg);
      const typeMatch = get(record, "typeId").match(reg);
      const ratifierMatch = get(record, "ratifiedBy").match(reg);
      const dateMatch = get(record, "uploadDate").match(reg);

      if (!titleMatch && !typeMatch && !ratifierMatch && !dateMatch) {
        return null;
      }
      return record;
    }).filter((record) => record);

    setSearchText(searchValue);
    setFilteredData(_filteredData);
  };

  const cancel = () => {
    // var msg = util.parseMessage(Messages.UPDATE_CANCELLED);
    // openNotification("Action cancelled successfully", msg, Notify.ERROR);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title-1",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => {
        return a.title.localeCompare(b.title);
      },
    },
    {
      title: "Document Type",
      dataIndex: "typeId",
      key: "typeId-2",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => {
        return a.typeId.localeCompare(b.typeId);
      },
    },
    {
      title: "Uploader",
      dataIndex: "uploadedBy",
      key: "Uploader-4",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => {
        return a.uploadedBy.localeCompare(b.uploadedBy);
      },
      ratification: true,
    },
    {
      title: "Uploaded Date",
      dataIndex: "uploadDate",
      key: "uploadDate-3",
      render: (text) => {
        return text != null ? moment(text).format("DD MMM YYYY, HH:mm") : "";
      },
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      defaultSortOrder: currentTab === ratificationQueue ? "ascend" : "descend",
      sorter: (a, b) => {
        return a.uploadDate.localeCompare(b.uploadDate);
      },
    },
    {
      title: "Ratified",
      dataIndex: "ratified",
      key: "ratified-4",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => {
        return a.ratified - b.ratified;
      },
      render: (value) => <CheckboxSwitchery checked={value} disabled={true} />,
      uploads: true,
      ratified: true,
    },
    {
      title: "Ratifier",
      dataIndex: "ratifiedBy",
      key: "ratifiedBy-4",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => {
        return a.ratifiedBy.localeCompare(b.ratifiedBy);
      },
      uploads: true,
      ratifiedBy: true,
    },
    {
      title: "Ratified Date",
      dataIndex: "dateRatified",
      key: "dateRatified-3",
      render: (text) => {
        return text != null ? moment(text).format("DD MMM YYYY, HH:mm") : "";
      },
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => {
        return a.dateRatified > b.dateRatified;
      },
      ratifiedDate: true,
    },
    {
      disabling: true,
      title: "Enabled",
      dataIndex: "disabled",
      key: "4",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => {
        return a.disabled - b.disabled;
      },
      render: (value) =>
        value === false ? (
          <CheckOutlined
            style={{
              fontSize: "18px",
              color: "#04a596",
              fontWeight: "bold",
            }}
          />
        ) : (
          <CloseOutlined
            style={{
              fontSize: "18px",
              color: "#a21b1b",
              fontWeight: "bold",
            }}
          />
        ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions-1",
      showOnResponse: true,
      showOnDesktop: true,
      render: (_, record) => {
        return (
          <>
            {currentTab === myUploads && (
              <>
                {record.ratified && (
                  <a
                    key={"a-" + record.id}
                    onClick={() => showModal(record, "view")}
                  >
                    View
                  </a>
                )}
                {!record.ratified && (
                  <a
                    key={"a-" + record.id}
                    onClick={() => showModal(record, "edit")}
                  >
                    Edit
                  </a>
                )}
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={() => confirmOwnDelete(record.id)}
                  onCancel={() => cancel()}
                  okText="Yes"
                >
                  {!record.ratified && (
                    <a
                      key={"del-" + record.id}
                      style={{ marginLeft: 10 }}
                    >
                      Delete
                    </a>
                  )}
                </Popconfirm>
              </>
            )}
            {currentTab === ratificationQueue && (
              <>
                {record.isOwner && (
                  <a
                    key={"a-" + record.id}
                    onClick={() => showModal(record, "view")}
                  >
                    View
                  </a>
                )}

                {!record.isOwner && (
                  <a
                    key={record.id}
                    onClick={() => showModal(record, "ratify")}
                  >
                    Ratify
                  </a>
                )}
              </>
            )}

            {currentTab === ratifiedRecords && (
              <>
                {
                  <a
                    key={"a-" + record.id}
                    onClick={() => showModal(record, "view")}
                  >
                    View
                  </a>
                }
                {record.disabled && (
                  <Popconfirm
                    title="Are you sure you want to enable this record?"
                    onConfirm={() => confirmDisabling(record, false)}
                    onCancel={() => cancel()}
                    okText="Yes"
                  >
                    <a
                      key={"del-" + record.id}
                      style={{ marginLeft: 10 }}
                    >
                      Enable
                    </a>
                  </Popconfirm>
                )}
                {!record.disabled && (
                  <Popconfirm
                    title="Are you sure you want to disable this record?"
                    onConfirm={() => confirmDisabling(record, true)}
                    onCancel={() => cancel()}
                    okText="Yes"
                  >
                    <a
                      key={"del-" + record.id}
                      style={{ marginLeft: 10 }}
                    >
                      Disable
                    </a>
                  </Popconfirm>
                )}
              </>
            )}
          </>
        );
      },
    },
  ] // filter columns based on selected tab
    .filter((item) => {
      if (currentTab === myUploads) {
        return (
          item.ratification === undefined &&
          item.ratifiedDate === undefined &&
          item.disabling === undefined &&
          item.ratifiedBy === undefined
        );
      } else if (currentTab === ratificationQueue) {
        return (
          item.uploads === undefined &&
          item.ratifiedDate === undefined &&
          item.disabling === undefined
        );
      } else {
        return item.ratified === undefined;
      }
    });

  const onRowChange = (row) => {
    setPageSize(row.pageSize);
  };
  return (
    <>
      <div>List of uploaded documents</div>
      <SearchControl
        handleInputChange={handleInputChange}
        searchText={searchText}
      />
      <div className="space"></div>
      {uploadingRatifier && (
        <>
          <Tabs
            className=""
            type="card"
            onChange={onTabChange}
            items={tabList}
            key="repo-table-1"
          />
          <div className="space"></div>
        </>
      )}
      <Table
        dataSource={loading ? [] : filteredData}
        // dataSource={docData}
        locale={{
          emptyText: loading ? <Skeleton active={true} /> : <Empty />,
        }}
        rowKey={(record) => "row-" + record.id}
        columns={columns}
        bordered
        pagination={{ pageSize: pageSize }}
        onChange={onRowChange}
        size="middle"
        mobileBreakPoint={768}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
            }, // click row
          };
        }}
      />
    </>
  );
}
